import { useState } from "react";
import { ConfirmActionModal } from "../../../components/ConfirmActionModal";
import { useArchiveProduct } from "../service/products-api";
import { DeleteButton } from "../../../components/NewButtons";
import { useNavigate } from "react-router-dom";
import { Product } from "../models/product";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { routes } from "../../../appRoutingHelpers";
import { toastr } from "react-redux-toastr";
import { ActionSpinner } from "../../../components/ActionSpinner";
import { getErrorMessage } from "../../../error-handler";

type Props = {
  product: Product;
};

export const DeleteProductSelector = ({ product }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const {
    mutateAsync: archiveProduct,
    isLoading: isDeletingProduct,
  } = useArchiveProduct();

  return (
    <>
      <DeleteButton
        type="button"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        Delete
      </DeleteButton>
      <ConfirmActionModal
        confirmButton={
          <DeleteButton
            type="button"
            onClick={async () => {
              try {
                await archiveProduct({
                  organizationKeyName,
                  data: { id: product?.id },
                });
                navigate(routes.products(organizationKeyName));
                toastr.success(
                  "Success",
                  "Product has been deleted successfully"
                );
                setIsOpen(false);
              } catch (error: unknown) {
                const message = getErrorMessage(error);
                toastr.error("Error", message);
              }
            }}
          >
            {isDeletingProduct ? <ActionSpinner /> : "Delete"}
          </DeleteButton>
        }
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Delete product?"
        subtitle="This cannot be undone."
      />
    </>
  );
};
